const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { connect } = require('react-redux');
// @ actions
const { toggleIbanModal } = require('actions/getAccounts');
// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { toFirstUppercase, getLastNChars } = require('utilities/stringHelper');
const { formatIbanString } = require('commonsUtilities/stringHelper');
const DateHelper = require('utilities/dateHelper');
const { getFormattedString } = require('utilities/currencyHelper');
// @ commons
const { IbanModal } = require('components/ibanModal/ibanModal');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ constants
const { LOANS_MORTGAGES_INVESTMENT_CREDIT } = require('constants/index');

class CreditInformation extends React.Component {

    constructor(props) {
        super(props);

        this.handleModalToggle = this.handleModalToggle.bind(this);
    }

    buildInformationList(immCredit) {
        const situationDate = immCredit.get('situationDate');
        const alias = immCredit.get('alias');
        const iban = immCredit.get('iban');
        const formattedIban = getLastNChars(iban, 4, '*', 4);
        const formattedAccount = `${alias} ${formattedIban}`
        const creditLimit = immCredit.get('limit');
        let fields;

        switch (immCredit.get('type')) {
            case LOANS_MORTGAGES_INVESTMENT_CREDIT:
                fields = [
                    {
                        title: formatText('investmentCredits-creditNumber'),
                        bodyText: formatIbanString(iban),
                        component: (
                            <div>
                                <IbanModal onRequestClose={this.handleModalToggle} />
                                <OKButton modifier="link-complementary" size="small" onClick={this.handleModalToggle}>
                                    <FormattedText value="whatIsIBAN-mainTitle" />
                                </OKButton>
                            </div>
                        )
                    },
                    {
                        title: formatText('investmentCredits-openingDate'),
                        bodyText: situationDate
                    },
                    {
                        title: formatText('investmentCredits-associatedAccount'),
                        bodyText: formattedAccount
                    },
                    {
                        title: formatText('investmentCredits-creditLimit'),
                        bodyText: getFormattedString(creditLimit)
                    }
                ];
                break;
            default:
                fields = [
                    {
                        title: formatText('credits-associatedAccount'),
                        bodyText: formattedAccount
                    },
                    {
                        title: formatText('credits-creditLimit'),
                        bodyText: getFormattedString(creditLimit)
                    },
                    {
                        title: formatText('credits-contractDate'),
                        bodyText: DateHelper.formatDate(immCredit.getIn(['details', 'startingDate']))
                    },
                    {
                        title: formatText('credits-dueDate'),
                        bodyText: DateHelper.formatDate(immCredit.getIn(['details', 'dueDate']))
                    }
                ];
                break;
        }

        return fields.map(({ title, bodyText, component }, index) => {
            if (!component) {
                return <OKInformativeListItem key={index} title={title} bodyText={bodyText} />;
            } else {
                return (
                    <OKInformativeListItem key={index} title={title} bodyText={bodyText}>
                        {component}
                    </OKInformativeListItem>
                );
            }
        });
    }

    buildInterveners() {
        const intervenersList = this.props.immInterveners.get('list');
        let content = intervenersList.map((intervener, index) => {
            const intervenerKey = `credits-information-intervener-${index}`;
            const interventionType = toFirstUppercase(intervener.get('type'));
            return (
                <OKInformativeListItem
                    key={intervenerKey}
                    title={interventionType}
                    bodyText={intervener.get('name')}
                />
            );
        }).toArray();

        return (
            <OKInformativeList title="credits-interveners" columns={2}>
                {content}
            </OKInformativeList>
        );
    }

    buildIntervenersError() {
        const handleRetry = this.props.getInformation;
        const primaryText = formatText('creditInformation-errorInterveners');
        const button = (
            <OKButton onClick={handleRetry}>
                <FormattedText value="creditInformation-retry" />
            </OKButton>
        );

        return (
            <EmptyState
                primaryText={primaryText}
                button={button}
                iconType="nointernet-banking" />
        );
    }

    handleModalToggle() {
        this.props.toggleIbanModal();
    }

    render() {
        const { immCredit, immInterveners } = this.props;
        const informationList = this.buildInformationList(immCredit);
        let intervenersList;

        if (immInterveners.get('isLoading')) {
            intervenersList = <LoadingSection />;
        } else if (immInterveners.get('error')) {
            intervenersList = this.buildIntervenersError();
        } else {
            intervenersList = this.buildInterveners();
        }

        return (
            <OKSectionBox title={formatText('credits-information')}>
                <article className="credits-information">
                    <section className="credit-information__body">
                        <OKInformativeList columns={2}>
                            {informationList}
                        </OKInformativeList>
                        {intervenersList}
                    </section>
                </article>
            </OKSectionBox>
        );
    }
}

CreditInformation.propTypes = {
    immCredit: PropTypes.object.isRequired,
    immInterveners: PropTypes.object.isRequired,
    toggleIbanModal: PropTypes.func.isRequired,
    getInformation: PropTypes.func.isRequired
};

module.exports.CreditInformation = connect(null, {
    toggleIbanModal
})(CreditInformation);
